import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { IConfirmMsisdnMigrationResult } from "./types";
import { multiOrderOrchestrator } from "./validators";

interface IConfirmMsisdnMigrationProps {
  orchestratorId: string;
}

export async function confirmMsisdnMigration({
  orchestratorId,
}: IConfirmMsisdnMigrationProps): Promise<IConfirmMsisdnMigrationResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/MIGRATION_CONFIRM`,
    {
      method: "post",
      validator: multiOrderOrchestrator,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
